/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesExportTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Export Type Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, December 09, 2019 - 04:11:05 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      12/09/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const ExportTypeList = Loadable({
    loader: () => import('../containers/ExportTypes/ExportTypeListContainer'),
    loading: Loading,
});

export const ExportTypeForm = Loadable({
    loader: () => import('../containers/ExportTypes/ExportTypeEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesExportTypes.js